import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hoom_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
}

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function imageUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND}${path}`;
}

export function tiktokHandle(input) {
  if (!input) return "";
  const s = String(input).trim();
  const m = s.match(/tiktok\.com\/@?([A-Za-z0-9._-]+)/i);
  if (m) return m[1];
  return s.replace(/^@+/, "").trim();
}

export default api;
